import React, { useEffect, useState } from "react";
import { Portal } from "react-portal";
import { useStores } from "_common/hooks";
import i18next from "i18next";

function ModalPrivacy({ open, onClose }) {
  const {
    authStore: { general },
  } = useStores();

  return (
    <Portal>
      <div
        className="modal modal-desktop"
        style={{ display: open ? "block" : "none" }}
      >
        <div className="mask" onClick={() => onClose()} />
        <div className="modal-content ">
          <div className="modal-header">
            <h2>{i18next.t("Privacy")}</h2>
            <div className="btn-close" onClick={() => onClose()}>
              X
            </div>
          </div>
          <div className="classic-bet-now">
            <div className="content">
              <p>
                ("The Company") understands the importance of including
                customers' personal information, and will comply with the
                provisions of the "Personal Information Protection Act" ("Act"),
                and endeavor to handle in an appropriate manner in accordance
                with the provisions of this privacy policy ("Privacy Policy")
                And protect personal information.
              </p>
              <p>1. Definition</p>
              <p>
                In the privacy policy, personal information refers to the
                “personal information” defined in the first paragraph of Article
                2 of the Act, that is, information related to living
                individuals. This information can use the name, date of birth or
                other information contained in the information (including easy
                association To other information, so as to identify a specific
                individual) in the description to identify a specific
                individual.
              </p>
              <p>2. Purpose of use</p>
              <p>
                The company uses customers’ personal information for the
                following purposes:
              </p>
              <p>Provide and improve the company's products or services;</p>
              <p>Notify the company's products, services or activities;</p>
              <p>
                Carry out marketing, survey or analysis to expand the scope of
                the company's products or services or improve their quality;
              </p>
              <p>Provide maintenance or support for the company's services;</p>
              <p>
                Notify the company of revisions to the terms of use, policies,
                etc. ("Terms") related to the services provided.
              </p>
              <p>
                Deal with violations of the terms of the company's services;
              </p>
              <p>Verify the account held by the user;</p>
              <p>
                Verify the transfer to the user's account; or communicate in
                emergency situations.
              </p>
              <p>Any other purpose related to the above purpose.</p>
              <p>3. Change the purpose of use</p>
              <p>
                The company can change the purpose of use of personal
                information so that the changed purpose of use can be reasonably
                regarded as related to the original purpose of use. After the
                purpose of use is changed, the company shall notify the user or
                publicly announce the changed purpose of use.
              </p>
              <p>4. Restrict use</p>
              <p>
                Without the consent of the relevant customer, the company shall
                not use personal information beyond the scope necessary for the
                realization of the purpose of use, unless permitted by the Act
                or other laws or regulations; however, this provision does not
                apply to the following situations:
              </p>
              <p>
                Use personal information in accordance with laws and
                regulations;
              </p>
              <p>
                The use of personal information is necessary to protect personal
                life, body or property, and it is difficult to obtain the
                consent of relevant customers;
              </p>
              <p>
                The use of personal information is necessary to improve public
                health or promote the physical and mental health of children,
                and it is difficult to obtain the consent of relevant customers;
              </p>
              <p>
                Or the use of personal information is necessary for the national
                government, local government, or individuals or entities
                entrusted to perform affairs prescribed by laws and regulations,
                and obtaining the consent of relevant customers may hinder the
                execution of related affairs.
              </p>
              <p>5. Appropriate collection</p>
              <p>
                The company may use appropriate means to collect personal
                information, but will not use deception or other improper means
                to collect personal information.
              </p>
              <p>6. Security Control</p>
              <p>
                The company fully and appropriately supervises its employees to
                ensure safe control of personal information to deal with the
                risk of loss, destruction, tampering or leakage.
              </p>
              <p>
                7. If the customer requests the company to correct, add or
                delete personal information on the grounds that the personal
                information is contrary to the facts in accordance with the
                provisions of the Act, the company should first confirm that the
                request was made by the person in charge, and then immediately
                make use of the purpose of use Carry out necessary
                investigations within the necessary scope, and then correct
                according to the investigation results, add or delete personal
                information, and notify the customer of the relevant situation
                (the company decides not to perform the correction, and the
                company shall notify the customer of the relevant situation when
                adding or deleting); but According to the provisions of the Act
                or other laws and regulations, the company is not obliged to
                perform corrections. When adding or deleting, the provisions do
                not apply.
              </p>
              <p>8. Forbidden</p>
              <p>
                If the customer requests the company to stop using or delete
                personal information on the grounds that the company’s
                processing of personal information exceeds the previously
                announced purpose of use or obtains personal information by
                deception or other improper means in accordance with the
                provisions of the Act, and the investigation proves that If the
                request is reasonable, the company should first confirm that the
                request was made by the person in charge, and then immediately
                stop using or delete personal information and notify the
                customer of the relevant situation; however, the company is not
                obliged to stop according to the Act or other laws and
                regulations. This rule does not apply when using or deleting
                personal information.
              </p>
              <p>
                9. Use information recording procedures and other technologies
              </p>
              <p>
                The services provided by the company may use information
                recording procedures or similar technologies. These technologies
                help the company understand the use of the company's services,
                etc. and continue to improve services. When the user wants to
                disable the information recording program, the user can change
                the settings of the web browser to disable the information
                recording program. Please note that after the information
                logging program is disabled, users will no longer be able to use
                some parts of the service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default ModalPrivacy;
